<div *ngIf="payments.length>0">
    <table id="example23" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
        <thead>
            <tr>
                <th>Email</th>
                <th>Fecha</th>
                <th>Descripción</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let payment of payments">
                <td>{{payment.userEmail}}</td>
                <td>{{payment.date|date:'shortDate'}}</td>
                <td>{{payment.description}}</td>
            </tr>
        </tbody>
    </table>
</div>